<template scope="scope">
  <el-dialog title="安装点开通" :visible.sync="dialogDeviceTypeFormVisible">
      <el-form style="margin-left:20px;" ref="configForm" :model="configForm" label-width="160px">

             <el-radio-group v-model="configForm.deviceType" @change="setDeviceType()">
                <el-radio  :label="1">关闭安装点</el-radio>
                <el-radio :label="2">开通普通安装点</el-radio>
                <el-radio :label="3">开通区域独家安装点</el-radio>
            </el-radio-group>
      </el-form>
    </el-dialog>

</template>

<script>

import BusinessModel from '@/framework/models/businessModel'

export default {
  name: 'set-device-type',
  data () {
    return {
      configForm: {
        deviceType: 1,
        id: null
      },
      dialogDeviceTypeFormVisible: false
    }
  },
  methods: {
    showDeviceType: function (data) {
      this.dialogDeviceTypeFormVisible = true
      this.configForm.deviceType = data.deviceType
      this.configForm.id = data.id
    },

    setDeviceType: function () {
      let _this = this
      let param = { 'id': this.configForm.id, 'deviceType': this.configForm.deviceType }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.$message({
              message: '修改成功！',
              type: 'success'
            })
          } else {
            _this.$message({
              message: '修改失败！',
              type: 'error'
            })
          }
          _this.$emit('onSuccess', null)
        }
      }
      BusinessModel.setDeviceType(_this, param, listener)
    },
    hideDialog () {
      this.dialogDeviceTypeFormVisible = false
    }
  }
}

</script>
